import { render, staticRenderFns } from "./AnswerPoints.vue?vue&type=template&id=e5cd5348&scoped=true&"
import script from "./AnswerPoints.vue?vue&type=script&lang=js&"
export * from "./AnswerPoints.vue?vue&type=script&lang=js&"
import style0 from "./AnswerPoints.vue?vue&type=style&index=0&id=e5cd5348&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5cd5348",
  null
  
)

export default component.exports